<template>
    <div>

 <div class="row">
      <div class="col-md-12">
        <div class="panal mt-20">
          <div class="panal-header">Academic Plan</div>
          <div class="panal-body">
           <h1>{{AcademicPlan[0].SpecializationNameEN}}</h1>
        


<b-col sm="12" md="12">

<div class="row">
<!-- <b-card  class="col-md-4 col-sm-12 select" border-variant="primary" sm="12"  v-if="empty">
   No Data
   </b-card> -->
  <div v-for = "(level , index) in levels" v-bind:key="index">
 <h5>{{level}}</h5>
 <div class="row">
        <div class="col-md-4 col-sm-12 mb-5"  border-variant="primary"  v-for="item in AcademicPlan.filter(x=>x.LevelName == level)" v-bind:Key="item.LevelName">

                         
                  <div class=" card p-4" :class="item.State == 'Pass' ? 'active2' : item.State == 'Fail' ? 'active' : '' ">
                    <b-card-text><strong>{{item.COURSENAME}}</strong></b-card-text>
                    <div class="text-center">
                      <b-button class="subButton">
                        <b-icon icon="check-circle-fill" aria-hidden="true"></b-icon>
                      </b-button>
                      
                      </div>
                      <div class="clearfix"></div>
                      </div>
         
           </div>
 </div>
                <!-- <div v-else-if="item.LevelName == 'Level 2'">
                <h5>Level (2)</h5>
                <div class=" card p-4">
                    <b-card-text><strong>{{item.COURSENAME}}</strong></b-card-text>
                    <div class="text-center">
                      <b-button class="subButton">
                        <b-icon icon="check-circle-fill" aria-hidden="true"></b-icon>
                      </b-button>
                      
                      </div>
                      <div class="clearfix"></div>
                </div>



                </div> -->

                <b-card  class="col-md-4 col-sm-12 select" border-variant="primary" sm="12"  v-if="empty">
   No Data
   </b-card>

           </div>
             


  </div>
   



  </b-col>





            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>





</div>
</template>


<script>
    import studentData from '../../services/student/studentDataServices';
    export default {
        name: 'AcademicPlan',
        data(){
            return{
                AcademicPlan: [], 
                message:'',
                isLoading : true,
                levels:[],
                Advdata : {},
                comp :[]
            }
        }, computed:{
           currenUser(){
            return  this.$store.state.auth.user
          }
       },
       mounted(){
         //this.currenUser.StudentID
           studentData.GetStudentState(this.currenUser.StudentID,0,0).then(Response =>{
               this.isLoading = false ;
               this.AcademicPlan = Response.data
                this.levels = this.AcademicPlan.map(item=> item.LevelName)
                this.levels = [...new Set(this.levels)]
                // eslint-disable-next-line no-console
                  // console.log('StudentState => ', )
           }, error => {
              
                  // eslint-disable-next-line no-console
                  // console.log(error.response.status)
                 
              this.message =
                (error.response && error.response.data && error.response.data.Message) ||
                error.message ||
                error.toString();
                
                if(error.response.status == 404) this.message =''
             
            }) 
       },
       

    };
</script>













<style >
h1{
    color: #285475;
    font-size: 25px;
    border-bottom: 1px #646464 dashed;
    padding: 10px 0px;
}
h1 a {
    color: #50BD77;
}

.panal{
  background:#fff;
  border-radius:10px;
color:#fff;
padding:0px 0px 20px 0px;
margin:10px 0;
   -webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.09) !important;
    margin-bottom: 20px !important;

}
.panal-header{
    background: #285475;
    color: #FFFFFF;
    text-align: left;
    border-radius: 10px 0px 0px 0px;
    padding: 10px 20px;
    font-size: 17px;
    font-weight: bold;
        width: 50%;
  /*  -moz-box-shadow:    inset 0 0 5px #000000;
   -webkit-box-shadow: inset 0 0 5px #000000;
   box-shadow:  */
}
.panal-body{
    padding:20px;
    color:#333;
}

.subButton{
  margin-bottom: -50px;
    width: 50%;
    background: #285476;
    text-align: center;
    border: 0px;
}
.card-deck{
  width: 100%  !important;
}

.active2 {
    color: #fff !important;    
    background-color: #007bff !important;
  }

  .active{
    background-color: rgba(0, 0, 0, 0.03);
    color:#333
  }
</style>